import { useEffect, useState } from 'react'
import FavoritesBtn from './FavoritesBtn'
import FavoritesHeartBtn from './FavoritesHeartBtn'
import ClearFavorites from './ClearFavorites'
import { get_cookie, set_cookie, delete_cookie } from 'utils'
import { SessionControllerType } from './interfaces'

const COOKIE_NAME = 'plant_search_favourites'

function SessionController({ plantID, btnType }: SessionControllerType) {
  const [fav, setFav] = useState(false)

  useEffect(() => {
    const cookie = get_cookie(COOKIE_NAME)
    if (cookie) {
      const exists = cookie.indexOf(plantID ?? '10000') !== -1
      setFav(exists)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleRemove = () => {
    const cookie = get_cookie(COOKIE_NAME)
    const removed = (cookie as string).replace(`${plantID}`, '')
    let processed = ''
    if (removed) {
      for (let i = 0; i < removed.length; i++) {
        if (
          (i === 0 && removed[i] === '|') ||
          (removed[i] === '|' && i === removed.length - 1) ||
          (i !== removed.length - 1 &&
            removed[i] === '|' &&
            removed[i + 1] === '|')
        ) {
          continue
        }
        processed += removed[i]
      }
    }

    set_cookie(COOKIE_NAME, processed)
    setFav(false)
  }
  const handleAdd = () => {
    const cookie = get_cookie(COOKIE_NAME)
    set_cookie(COOKIE_NAME, `${cookie ? cookie + '|' : ''}${plantID}`)
    setFav(true)
  }

  const handleClear = () => {
    delete_cookie(COOKIE_NAME)
    window.location.reload()
  }
  switch (btnType) {
    case 'btn':
      return (
        <FavoritesBtn
          handleAdd={handleAdd}
          handleRemove={handleRemove}
          saved={fav}
        />
      )
    case 'clear':
      return <ClearFavorites handleClear={handleClear} />
    case 'heart':
      return (
        <FavoritesHeartBtn
          handleAdd={handleAdd}
          handleRemove={handleRemove}
          saved={fav}
        />
      )
    default:
      return <></>
  }
}

export default SessionController
